import React, { FC, useEffect, useState } from 'react';
import IconButton, {
  VariantBg
} from '../../design-system/IconButton/IconButton';
import MenuIcon from '../../../icons/Menu';
import CloseIcon from '../../../icons/Close';

interface Props {
  darkStyle?: boolean;
  isForceOpened?: boolean;
  onClick?: () => void;
}

const BurgerButton: FC<Props> = ({ isForceOpened, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (): void => {
    setIsOpen((state) => !state);
    onClick();
  };

  useEffect(() => {
    setIsOpen(isForceOpened);
  }, [isForceOpened]);

  return (
    <IconButton
      data-cy={isOpen ? 'burger_button_close' : 'burger_button_open'}
      className="l:hidden"
      onClick={handleClick}
      icon={
        isOpen
          ? {
              alt: 'close',
              component: CloseIcon
            }
          : {
              alt: 'menu',
              component: MenuIcon
            }
      }
      isBg={false}
      variantBg={VariantBg.DARK}
    />
  );
};

export default BurgerButton;
